import React, { useEffect, useState } from 'react'
import { ProductFruits } from 'react-product-fruits'
import { useSelector } from 'src/store/redux.store'

import { hasToRenderProductFruits } from './product-fruits.utils'
import { PRODUCT_FRUIT_ID, LANG_ISO_2 } from './product-fruits.constants'
import { useExtensionsSubscriptions } from './extensions-subscriptions'
import { IProductFruitsUserProp } from './product-fruits.interfaces'

const RenderProductFruits = () => {
  const { user } = useSelector(state => state)

  const [productFruitLang, setProductFruitLang] = useState(null)
  const [productFruitsUserProp, setProductFruitsUserProp] = useState<IProductFruitsUserProp | null>(null)
  const { productFruitsExtensionsSubscriptions } = useExtensionsSubscriptions()

  const {
    email,
    language,
    name,
    isProducerOrSeller,
    productions,

    profile: {
      signupDate,
      lastAccess,
      status,
      hasSale,
      numberOfLogins,
      extensions,
      extensionsFreemium,
      userId,
      intentionName
    }
  } = user

  useEffect(() => {
    setProductFruitLang(LANG_ISO_2[language] || LANG_ISO_2.EN)
  }, [user])

  useEffect(() => {
    if (productFruitsExtensionsSubscriptions) {
      const productFruitsUserData = {
        username: email,
        props: {
          name,
          language,
          signupDate,
          lastAccess,
          status,
          numberOfLogins,
          userId,
          intentionName,
          isProducerOrSeller: String(isProducerOrSeller),
          productions: productions.length,
          hasSale: String(hasSale),
          extensions: String(extensions),
          extensionsFreemium: String(extensionsFreemium),
          ...productFruitsExtensionsSubscriptions
        }
      }

      setProductFruitsUserProp(productFruitsUserData)
    }
  }, [productFruitsExtensionsSubscriptions])

  const isRenderProductFruits = hasToRenderProductFruits(user) && productFruitLang && productFruitsUserProp

  return isRenderProductFruits ? (
    <div className="_d-none" data-testid="product-fruits-container" id="product-fruits-bw">
      <ProductFruits language={productFruitLang} user={productFruitsUserProp} workspaceCode={PRODUCT_FRUIT_ID} />
    </div>
  ) : null
}

export default RenderProductFruits
